export const currentSkillsList = [
  "Semantic & accessible HTML",
  "JavaScript (ES6+)",
  "TypeScript",

  "Responsive Web Design",
  "Immutability",
  "Terminal",

  "CSS BEM Convention",
  "Working with API (XMLHttpRequest, Fetch, Axios)",
  "NPM",

  "OpenGraph protocol",
  "Promise, Async/Await",
  "Git",

  "Normalize.css",
  "Error handling",
  "Git branching",

  "box-sizing: border-box",
  "Local Storage & Cookies",
  "GitHub",

  "Media Queries",
  "JSON",
  "Pull Requests & Review",

  "CSS Flexbox",
  "React.js",
  "Teamwork",

  "CSS Grid",
  "Redux (Toolkit)",
  "Scrum",

  "CSS Transitions",
  "Redux-Saga & generator functions",
  "Figma",

  "Web Fonts",
  "React Router",
  "Trello",

  "SVG",
  "Styled Components",
  "Markdown",
];

export const futureSkillsList = [
  "Next.js",
  "React Context",
  "Cypress",
  "Unit testing",
  "JS classes",
];
